import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { ReactComponent as DefaultImage } from '../../../images/common/default_image.svg';

export const FrameWrapper = styled.div`
  margin-top: 18px;
  &:last-child {
    margin-bottom: 8px;
  }
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #bbbbbb;
  padding: 16px 0px 16px 21px;
`;

export const PictureWrapper = styled.div`
  width: 240px;
  height: 180px;
  background-color: ${props =>
    props.workRecord ? ColorSF2.white : ColorSF2.lightGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const PictureImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const StyleDefaultImage = styled(DefaultImage)`
  width: 136px;
  height: 136px;
  fill: ${ColorSF2.mediumGray};
  vertical-align: middle;
`;

export const PictureDescription = styled.span`
  color: ${ColorSF2.mediumGray};
  font-weight: bold;
`;

export const NoteWrapper = styled.div`
  margin: 16px 11px 16px 16px;
  display: flex;
  flex-direction: column;
`;

export const FrameLabel = styled.span`
  border-top: 1px solid ${ColorSF2.mediumGray};
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 8px;
  font-size: 12px;
  color: ${ColorSF2.steelGray};
  font-weight: 100;
`;

export const TextareaWithCountWrapper = styled.div`
  margin-top: 10px;
`;
